import anime from 'animejs'
import plangridTrackEvents from './amplitudeInit-vanilla';
import getPageNameFromLocation from '../../pages/helpers/getPageNameFromLocation';
import phoneDemoEvents from './phoneDemo';

export const init = () => {
  const pageName = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pageName);
  phoneDemoEvents();
}

document.addEventListener('DOMContentLoaded', init)



// WEBPACK FOOTER //
// ./src/assets/js/regional.js